export type TCellProps = {
  children: React.ReactNode;
  columnId: string;
};

export const TCell = ({ children }: TCellProps) => {
  return <>{children}</>;
};
